import { useMutation } from '@apollo/client';
import type { DeleteIndicatorsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteIndicatorsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteIndicatorsTRPC } from './useDeleteIndicatorsTRPC';

export const useDeleteIndicators = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteIndicatorsGraphQL, graphqlState] = useMutation(
    DeleteIndicatorsDocument,
    {
      update: (cache) => evictField(cache, 'indicator'),
    }
  );

  const trpcMutation = useDeleteIndicatorsTRPC();

  const deleteIndicators = async (
    ids: string[]
  ): Promise<DeleteIndicatorsMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteIndicators(ids);
    }

    const result = await deleteIndicatorsGraphQL({
      variables: { ids },
    });
    if (!result.data) {
      throw new Error('Failed to delete indicators');
    }

    return result.data;
  };

  if (trpcEnabled) {
    return {
      deleteIndicators,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteIndicators,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
